import React from "react";
import styles from "../../styles/layout/Header.module.css";

const Header = ( props ) => {

    return (
        <div className={`${styles.header} ${ props.background ? styles.headerT : styles.headerW }`}>
            <div className={styles.logo}>
                <a href="/">
                    <img src={`${process.env.PUBLIC_URL}/main/1p/1p-오퍼그룹로고_수정.png`} alt="logo"></img>
                </a>
            </div>
            <nav className={styles.nav}> 
                <ul className={styles.navLinks}>
                    <li><a href="/company">회사소개</a></li>
                    <li><a href="/services">서비스소개</a></li>
                    {/* <li><a onClick={addtionsClick} href="#!">부가서비스</a></li> */}
                    <li><a href="/news">보도자료</a></li>
                    <li><a href="/partner">제휴사모집</a></li>
                    <li><a href="/contact">문의하기</a></li>
                </ul>
            </nav>
            <div className={styles.userInfo}>
                <img src={`${process.env.PUBLIC_URL}/main/1p/1p-회원로고_Png.png`} alt="User" className={styles.user} />
                <img src={`${process.env.PUBLIC_URL}/main/1p/1p-돋보기_Png.png`} alt="Search" className={styles.search} />
            </div>
        </div>
    );
};

export default Header;